var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.division
        ? [
            _c(
              "div",
              { staticClass: "panel wraper panel-gray" },
              [
                _c(
                  "div",
                  { staticClass: "panel-header" },
                  [
                    _c(
                      "transition",
                      {
                        attrs: {
                          name: _vm.transName || "slide-l",
                          mode: "out-in"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            key: _vm.$route.params.id,
                            staticClass: "panel-title"
                          },
                          [_c("unit-path", { attrs: { id: _vm.id } })],
                          1
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "transition",
                  {
                    attrs: { name: _vm.transName || "slide-l", mode: "out-in" }
                  },
                  [
                    _c(
                      "div",
                      { key: _vm.$route.params.id, staticClass: "panel-body" },
                      [
                        _vm.division.lastEdited
                          ? _c("p", { staticClass: "in-top" }, [
                              _c(
                                "small",
                                { staticClass: "view-label" },
                                [
                                  _c("q-icon", {
                                    attrs: { name: "fas fa-user-edit" }
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.editor) +
                                      " " +
                                      _vm._s(
                                        _vm._f("formatTime")(
                                          _vm.division.lastEdited
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.division.abbr
                          ? _c("p", [
                              _c("small", { staticClass: "view-label" }, [
                                _vm._v("Назв.сокр-ное")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-bolder" }, [
                                _vm._v(_vm._s(_vm.division.abbr))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.division.fullName
                          ? _c("p", [
                              _c("small", { staticClass: "view-label" }, [
                                _vm._v("Назв\n              ание")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-bolder" }, [
                                _vm._v(_vm._s(_vm.division.fullName))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.division.address
                          ? _c("p", [
                              _c("small", { staticClass: "view-label" }, [
                                _vm._v("Адрес")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-bolder" }, [
                                _vm._v(_vm._s(_vm.division.address))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.formatTel
                          ? _c("p", [
                              _c("small", { staticClass: "view-label" }, [
                                _vm._v("Контакты")
                              ]),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "text-bolder",
                                domProps: { innerHTML: _vm._s(_vm.formatTel) }
                              })
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.division.comment
                          ? _c("p", [
                              _c("small", { staticClass: "view-label" }, [
                                _vm._v("Заметки")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-bolder" }, [
                                _vm._v(_vm._s(_vm.division.comment))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("media-bar", {
                          attrs: { medias: _vm.mediasCopy },
                          on: { selectMedia: _vm.showAttach }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "panel panel-gray" },
                          [
                            _c("q-tree", {
                              attrs: {
                                nodes: _vm.tree,
                                "node-key": "_id",
                                selected: _vm.selected
                              },
                              on: {
                                "update:selected": function($event) {
                                  _vm.selected = $event
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.notReader
              ? _c("pop-btn", {
                  staticClass: "mobile-hide",
                  attrs: { btns: _vm.btns }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.notReader
              ? _c("pop-hold", {
                  staticClass: "mobile-only",
                  attrs: { btns: _vm.btns }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("media-modal", {
              ref: "mediaModal",
              attrs: { done: _vm.createAttach }
            })
          ]
        : [
            _c(
              "div",
              { staticClass: "row justify-center" },
              [
                _c("q-spinner-dots", { attrs: { size: 100, color: "primary" } })
              ],
              1
            )
          ],
      _vm._v(" "),
      _c("mediator", {
        ref: "mediator",
        attrs: { editEnabled: _vm.notReader },
        on: {
          mediaEdited: _vm.mediaEdited,
          mediaDeleted: _vm.mediaDeleted,
          doNext: _vm.doNext
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-718258f6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-718258f6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/division-view.vue
// module id = null
// module chunks = 